import script from "./tableCont.vue?vue&type=script&lang=jsx&setup=true"
export * from "./tableCont.vue?vue&type=script&lang=jsx&setup=true"

import "./tableCont.vue?vue&type=style&index=0&id=5b0bd594&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0bd594"]])

export default __exports__